"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const http_1 = require("../http");
const putShipmentWaypointDriveThrough = async ({ axios, shipmentId, waypointId, drivenThroughAt }) => {
    const { data: { createdAt } } = await http_1.httpPut({
        axios,
        url: `new-shipments/${shipmentId}/waypoints/${waypointId}/drive-through`,
        data: { drivenThroughAt }
    });
    return new Date(createdAt);
};
exports.default = putShipmentWaypointDriveThrough;
